<h3 class="attributes-groupe header-text">BCF</h3>
<div class="bcf--viewpoints">
  <ngx-gallery [options]="galleryOptions"
               [images]="galleryImages"
               (previewOpen)="galleryPreviewOpen()"
               (previewClose)="galleryPreviewClose()">
  </ngx-gallery>
</div>
